export default "__VITE_ASSET__C8drXXE2__"